<template>
    <div class="login-page">
        <div class="login-info" :style="{backgroundImage:'url('+basicInfo.backgroundUrl+')'}">
            <div class="pro-title">{{basicInfo.sysName}}</div>
            <div class="pro-des">{{basicInfo.description}}</div>
        </div>
        <div class="login-content">
            <div class="login-logo">
                <img :src="basicInfo.logo" alt="">
                <span>{{basicInfo.logoName}}</span>
            </div>
            <img class="colorful" src="../../assets/img/colorful.png" alt="">
            <div class="login-tab">
                <div class="tab-title">登录</div>
                <div class="login-head">
                    <div class="login-way">
                        <div @click="chooseTab(1)" :class="{'active':currentTab==1}">手机号登录</div>
                        <span class="line line1" v-if="currentTab==1"></span>
                    </div>
                    <div class="login-way">
                        <div @click="chooseTab(2)" :class="{'active':currentTab==2}">账号登录</div>
                        <span class="line line2" v-if="currentTab==2"></span>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div v-if="currentTab==1" style="padding:46px 0px 0">
                    <a-input v-model.trim="loginMessage.bindedPhoneNum" style="height:52px;border:none;background: rgba(188, 202, 214, 0.2);" placeholder="请输入手机号" />
                    <div style="margin-top:20px;height:52px">
                        <VerificationCode :message="loginMessage" ref='loginCode'></VerificationCode>
                    </div>
                    <a-button @click="loginInPhone" style="margin-top:20px;width:100%;height:52px;" type="primary">
                    登录
                    </a-button>
                </div>
                <div v-if="currentTab==2" style="padding:46px 0px 0">
                    <a-input id="aa" v-model="loginPwd.phone" style="height:52px;border:none;background: rgba(188, 202, 214, 0.2);" placeholder="请输入手机号" />
                    <a-input @keyup.enter="loginInPwd()" type="password" v-model="loginPwd.password" style="height:52px;border:none;background: rgba(188, 202, 214, 0.2);margin-top:20px;" placeholder="请输入密码" />
                    <a-button @click="loginInPwd" style="margin-top:20px;width:100%;height:52px;" type="primary">
                    登录
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VerificationCode from '../../components/VerificationCode'
export default {
    name: 'Login',
    props: {
        msg: String
    },
    components: { VerificationCode },
    data() {
        return {
            currentTab: 1,
            loginMessage: {
                bindedPhoneNum: '',
                type: 1
            },
            loginPwd: {
                phone: '',
                password: ''
            },
            appInfo: '',
            appId: '',
            basicInfo: '',
            pageTitle: '',
            faviconIcon: ''
        }
    },
    methods: {
        chooseTab(type) {
            this.currentTab = type
        },
        loginInPhone() {
            this.axios.post('/api/login/phone/verifyCode', {
                phone: this.loginMessage.bindedPhoneNum,
                verifyCode: this.$refs.loginCode.verificationCode,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.sessionData('set','token',response.data.data.token)
                    this.$router.push({path: "/ExternalPage", query: {key: 1}})
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        loginInPwd() {
            this.axios.post('/api/login/phone/password', {
                phone: this.loginPwd.phone,
                password: this.loginPwd.password,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.sessionData('set','token',response.data.data.token)
                    this.$router.push({path: "/ExternalPage", query: {key: 1}})
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        queryBasicInfo() {
            let host = window.location.host
            this.axios(
                {
                method:'get',
                url:'/api/login/loginInfo', 
                params: {
                    hostName: host,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.basicInfo = response.data.data
                    this.pageTitle = response.data.data.sysName
                    this.faviconIcon = response.data.data.titleLogo
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        }
    },
    mounted: function() {
        this.queryBasicInfo()
    },
    updated() {
        document.title = this.pageTitle;
        const favicon = document.getElementById('dynamic-favicon');
        favicon.href = this.faviconIcon
    }
}
</script>

<style scoped lang="less"> 
    .login-page{
        width: 100%;
        height: 100%;
        display: flex;
        .login-info{
            width: 640px;
            height: 100%;
            // background: url('../../assets/img/login-bg.jpg');
            padding: 196px 0 0 120px;
            .pro-title{
                color: rgba(18, 18, 18, 1);
                font-size: 40px;
                letter-spacing: 1px;
            }
            .pro-des{
                color: rgba(44, 64, 90, 1);
                font-size: 16px;
                margin-top: 32px;
            }
        }
        .login-content{
            flex: 1;
            position: relative;
            background: #fff;
            .colorful{
                position: absolute;
                right: 0;
                top: 0;
                width: 360px;
            }
            .login-logo{
                position: absolute;
                left: 60px;
                top: 20px;
                img{
                    width: 48px;
                    float: left;
                    margin-right: 8px;
                }
                span{
                    color: rgba(0, 0, 0, 1);
                    font-size: 20px;
                    float: left;
                    font-weight: bold;
                    margin-top: 8px;
                }
            }
            .login-tab{
                width: 320px;
                height: 400px;
                float:left;
                margin: 200px auto;
                position: absolute;
                left: 50%;
                margin-left: -160px;
                .tab-title{
                    color: rgba(0, 0, 0, 1);
                    font-size: 26px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
            .login-head{
                .login-way{
                    display: inline-block;
                    margin-right: 32px;
                    color: rgba(0, 0, 0, 1);
                    font-size: 18px;
                    cursor: pointer;
                    text-align: center;
                    position: relative;
                    text-align: center;
                    float: left;
                }
                div.active{
                    color: #22D7BB;
                }
                .line{
                    display: inline-block;
                    width: 32px;
                    height: 4px;
                    background: rgba(34, 215, 187, 1);
                    text-align: center;
                    float: left;
                    margin-top: 4px;
                    position: absolute;
                    left: 50%;
                }
                .line1{
                    margin-left: -16px;
                }
                .line2{
                    margin-left: -16px;
                }
            }
        }
    }
    .ant-input:focus {
        border: none;
        box-shadow: none;
    }
</style>
